import { SentryUserType, UserType } from '../types';
import jwtDecode, { JwtPayload } from 'jwt-decode';

const MS_PER_MINUTE: number = 60000;
const MS_PER_SECOND: number = 1000;

const isTokenExpired = (token: string): boolean => {
  const decoded = jwtDecode<JwtPayload>(token);
  return Date.now() >= decoded.exp! * MS_PER_SECOND - MS_PER_MINUTE;
};

const getFixedUser = (): UserType => {
  let fixedUser = {
    access_token: process.env.REACT_APP_FIXED_USER_ACCESS_TOKEN,
    foto: process.env.REACT_APP_FIXED_USER_FOTO,
    id_usuario: parseInt(process.env.REACT_APP_FIXED_USER_ID || '0'),
    nome: process.env.REACT_APP_FIXED_USER_NOME,
    refresh_token: process.env.REACT_APP_FIXED_USER_REFRESH_TOKEN,
  };
  return fixedUser;
};

const extractSentryProps = (user: UserType): SentryUserType => {
  const { id_usuario: id, nome: username } = user;
  return { id, username };
};

const AuthHelper: { [key: string]: any } = {
  extractSentryProps: extractSentryProps,
  getFixedUser: getFixedUser,
  isTokenExpired: isTokenExpired,
};

export default AuthHelper;
